import React from "react"
import { AppLayout } from "@kit/design/app-layout"
import { AppNavigation } from "app/navigation/app-navigation"
import { LayoutBanners } from "./layout-banners"

export function VerticalNavLayout({ layoutConfig, children }) {
  return (
    <AppLayout>
      <AppNavigation />
      <AppLayout.Content>
        <LayoutBanners layoutConfig={layoutConfig} />
        {children}
      </AppLayout.Content>
    </AppLayout>
  )
}
